import React from "react";
import { withRouter } from "react-router-dom";
import withDefaultParams from "Services/withDefaultParams";

const SeoTextProviderRatesTags = props => {
    let {
        match: {
            params: { tagCode },
        },
        siteCode,
        useTag,
        region,
        providerInfo,
        tariffList,
    } = props;

    const speedMeasure = () => {
        return `<span style="white-space: nowrap">Мбит/с</span>`;
    };

    const internetIMobilnayaSvyaz101 = () => {
        let tariffNamesInternetSpeedMinList = !!tariffList.info
            .tariffNamesInternetSpeedMinList
            ? tariffList.info.tariffNamesInternetSpeedMinList.split(",")
            : [];
        let tariffNamesInternetSpeedMaxList = !!tariffList.info
            .tariffNamesInternetSpeedMaxList
            ? tariffList.info.tariffNamesInternetSpeedMaxList.split(", ")
            : [];

        return `
<p>Домашний интернет и мобильную связь можно смело отнести к одним из основных потребностей современного человека.</p>
<p>Провайдер ${
            providerInfo.name
        } предлагает различные тарифы домашнего интернета и мобильной связи. Чтобы выбрать тот, который вам подойдёт, для начала нужно понять, как вы планируете использовать подключение. От этого напрямую зависит, какая скорость интернета вам понадобится.</p>
<p>Для людей, выходящих в сеть ради повседневных задач, таких как чтение новостей, работа, общение в социальных сетях, просмотр сериалов, ${
            tariffNamesInternetSpeedMinList.length === 1
                ? "подойдет"
                : "подойдут"
        } ${tariffList.info.tariffNamesInternetSpeedMinList} со скоростью ${
            useTag.internet.speedMin
        } ${speedMeasure()}.</p>
<p>Если для вас важно иметь возможность быстро загружать в сеть большие массивы данных, вы любите смотреть фильмы в наилучшем качестве и все в вашей семье привыкли использовать интернет по максимуму — стоит обратить внимание на ${
            tariffNamesInternetSpeedMaxList.length === 1 ? "тариф" : "тарифы"
        } ${
            tariffList.info.tariffNamesInternetSpeedMaxList
        } со скоростью подключения до ${
            useTag.internet.speedMax
        } ${speedMeasure()}.</p>
<p>А для тех, кто любит общаться по телефону, приятным дополнением станут пакеты минут, которые можно потратить на общение с друзьями и близкими по всей России.</p>
<p>Вне зависимости от тарифа провайдер ${providerInfo.name} предлагает вам:</p>
<ul>
<li>хорошее покрытие сети по ${region.declinations.dative};</li>
<li>высокое качество сигнала, без шумов и помех на линии;</li>
<li>подключение к интернету без сбоев и зависаний.</li>
</ul>
<p>Выбрать тарифный план для подключения интернета и мобильной связи очень просто. Мы собрали все варианты в одном месте и теперь вы можете сравнить их и подобрать наиболее подходящий.</p>
<p>Оставить заявку на подключение понравившегося тарифа можно прямо на нашем сайте.</p>
    `;
    };

    const internetTvMobile101 = () => {
        let tariffNamesMobileCallsMaxList = !!tariffList.info
            .tariffNamesMobileCallsMaxList
            ? tariffList.info.tariffNamesMobileCallsMaxList.split(", ")
            : [];
        let tariffNamesTvChannelsMaxList = !!tariffList.info
            .tariffNamesTvChannelsMaxList
            ? tariffList.info.tariffNamesTvChannelsMaxList.split(", ")
            : [];

        return `
<p>Домашний интернет, ТВ и мобильная связь — это цифровая основа социальной и культурной жизни современного человека. В интернете и по ТВ мы узнаём новости и смотрим фильмы. В сети и по мобильной связи — общаемся с близкими. Что бы мы ни делали, хороший сигнал и стабильная связь важны всегда. Хорошо, что провайдер ${
            providerInfo.name
        } позаботился об этом.</p>
<p>Осталось только понять, какой именно тариф интернета, ТВ, мобильной связи выбрать.</p>
<p>Всё зависит от ваших потребностей и задач.</p>
<p>Если вам нужно проводить много времени в интернете и работать с большими объёмами данных, то стоит обратить внимание на ${
            tariffList.info.tariffNamesInternetSpeedMaxList
        }, с возможностью подключения со скоростью до ${
            useTag.internet.speedMax
        } ${speedMeasure()}.</p>
<p>Если вы любите долгое общение по телефону, то вас заинтересуют возможности ${
            tariffNamesMobileCallsMaxList.length === 1 ? "тарифа" : "тарифов"
        } ${
            tariffList.info.tariffNamesMobileCallsMaxList
        } — с предоставлением до ${
            useTag.mobile.callsMax
        } минут разговоров в месяц.</p>
<p>Если же вы не представляете свою жизнь без телевидения, то вы точно оцените ${
            tariffNamesTvChannelsMaxList.length === 1 ? "тариф" : "тарифы"
        } ${
            tariffList.info.tariffNamesTvChannelsMaxList
        }. В вашем доступе будет ${
            useTag.tv.allChannelMax
        } каналов, из которых вы наверняка выберете для себя подходящий.</p>
<p>Какой бы тариф вы ни выбрали, в каждом из них вас ждут:</p>
<ul>
<li>доступ к интернету без зависаний и сбоев;</li>
<li>качественная телефонная связь;</li>
<li>доступ к каналам телевидения.</li>
</ul>
<p>На нашем сайте вы можете изучить таблицу со всеми доступными тарифами и выбрать для себя наиболее подходящий под ваши требования вариант.</p>
<p>Оставить заявку на подключение можно прямо на нашем сайте.</p>
    `;
    };

    const domashnijInternet101 = () => {
        let tariffNamesInternetSpeedUnder100List = !!tariffList.info
            .tariffNamesInternetSpeedUnder100List
            ? tariffList.info.tariffNamesInternetSpeedUnder100List.split(", ")
            : [];

        return `
<p>Домашний интернет нужен практически всем. Если вы работаете или учитесь из дома, смотрите фильмы и сериалы в интернете, общаетесь по видеосвязи и в социальных сетях, используете различные устройства умного дома — вы точно заинтересованы в хорошем тарифе домашнего интернета.</p>
<p>Провайдер ${
            providerInfo.name
        } предлагает различные варианты для подключения интернета в вашем доме или квартире. Чтобы немного облегчить вам выбор, мы собрали все предложения в одном месте и теперь вам не придётся просматривать множество разных сайтов.</p>
<p>Выберите для себя подходящий вариант:</p>
<ul>
<li>${tariffNamesInternetSpeedUnder100List.length === 1 ? "тариф" : "тарифы"} ${
            tariffList.info.tariffNamesInternetSpeedUnder100List
        } со скоростью до 100 ${speedMeasure()} — для тех, кому интернет нужен для повседневных задач;</li>
<li>тарифы со скоростью от 100 ${speedMeasure()} и выше — если активных пользователей сети много, то следует рассмотреть этот вариант, чтобы сигнала точно хватило на всех.</li>
</ul>
<p>Выбирайте подходящий тариф и платите от ${useTag.price.priceMin} ${
            useTag.price.priceMin != useTag.price.priceMax
                ? `до ${useTag.price.priceMax}`
                : ""
        } рублей в месяц в зависимости от выбранной вами скорости подключения.</p>
<p>Домашний интернет от ${
            providerInfo.name
        } — это стабильное высокоскоростное подключение без сбоев и зависаний. Выберите и подключите тариф и наслаждайтесь качественным соединением.</p>
<p>Оставить заявку на подключение вы можете прямо на нашем сайте и с вами обязательно свяжутся.</p>
    `;
    };

    const internetITv101 = () => {
        return `
<p>Домашний интернет и телевидение являются главными источниками новостей в современном мире. Если вы хотите быть в курсе событий и вовремя узнавать всё самое важное — стоит позаботиться о выгодном тарифе интернета и ТВ.</p>
<p>Провайдер ${
            providerInfo.name
        } предлагает тарифы, которые включают отличный высокоскоростной интернет, а также доступ к минимум ${
            useTag.tv.allChannelMin
        } каналам.</p>
<p>Скорость интернета ${
            useTag.internet.speedMin != useTag.internet.speedMax
                ? `от ${useTag.internet.speedMin}`
                : ""
        } до ${
            useTag.internet.speedMax
        } ${speedMeasure()} позволит вам комфортно проводить время в сети и не беспокоиться о том, что интернет зависнет в самый неподходящий момент.</p>
<p>Наличие ${
            useTag.tv.allChannelMin != useTag.tv.allChannelMax
                ? `от ${useTag.tv.allChannelMin}`
                : ""
        } до ${
            useTag.tv.allChannelMax
        } каналов даёт возможность подобрать программу по своему вкусу.</p>
<p>Почему стоит подключить тариф с домашним интернетом и ТВ:</p>
<ul>
<li>возможность оплачивать услуги в одном месте;</li>
<li>выгодная цена от ${useTag.price.priceMin} рублей в месяц;</li>
<li>одновременное подключение сразу двух необходимых услуг.</li>
</ul>
<p>Вы можете ознакомиться со всеми тарифными планами на нашем сайте, сравнить их и выбрать наиболее подходящий.</p>
<p>Для подключения тарифа оставьте заявку на сайте и с вами обязательно свяжутся.</p>
    `;
    };

    const nedorogojDomashnijInternet101 = () => {
        let fullYear = new Date().getFullYear();
        let text = () => {
            return `
            <p>Для большой семьи, где все активно используют интернет, подойдёт вариант со скоростью до ${
                useTag.internet.speedMax
            } ${speedMeasure()}.</p>
            `;
        };

        return `
<p>Мы все любим выгодные предложения. Особенно если речь идёт о подключении необходимой услуги. В ${fullYear} году провайдер ${
            providerInfo.name
        } предлагает вам выгодные условия подключения домашнего интернета.</p>
<p>Это отличная возможность получить хорошее, стабильное интернет-соединение по цене от ${
            useTag.price.priceMin
        } ${
            useTag.price.priceMin != useTag.price.priceMax
                ? `до ${useTag.price.priceMax}`
                : ""
        } рублей в месяц.</p>
<p>За эти деньги вы получите:</p>
<ul>
<li>скорость ${
            useTag.internet.speedMin != useTag.internet.speedMax
                ? `от ${useTag.internet.speedMin}`
                : ""
        } до ${useTag.internet.speedMax} ${speedMeasure()};</li>
<li>стабильное подключение;</li>
<li>квалифицированную помощь службы поддержки.</li>
</ul>
<p>Чтобы выбрать подходящий тарифный план, стоит учитывать, как вы планируете использовать сетевое подключение.</p>
<p>Если для вас самое главное — работа, учёба и общение с близкими в социальных сетях, отдайте предпочтение тарифу со скоростью до 100 ${speedMeasure()}.</p>
${useTag.internet.speedMax > 100 ? `${text()}` : ""}
<p>Всегда непросто сделать выбор, особенно когда вариантов много. Чтобы облегчить вашу задачу, мы собрали все предложения в одном месте. Вам осталось только выбрать подходящее.</p>
<p>Чтобы подключить услугу, оставьте заявку на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const internet100Mbit101 = () => {
        let tariffNamesWithChannelList = !!tariffList.info
            .tariffNamesWithChannelList
            ? tariffList.info.tariffNamesWithChannelList.split(", ")
            : [];

        let text = () => {
            return `
<p>Например, при выборе ${
                tariffNamesWithChannelList.length === 1 ? "тарифа" : "тарифов"
            } ${
                tariffList.info.tariffNamesWithChannelList
            } вы также получите доступ к телевизионным каналам.</p>
            `;
        };

        return `
<p>Хорошая скорость подключения к сети — залог комфортной работы в интернете. Интернет со скоростью 100 ${speedMeasure()} позволит вам заниматься своими делами, учиться, читать новости и смотреть фильмы, не беспокоясь о том, что соединение зависнет.</p>
<p>Выбор провайдера домашнего интернета — это всегда непросто и отнимает много времени. Чтобы помочь вам найти лучший вариант, мы собрали все предложения провайдера ${
            providerInfo.name
        } в ${region.declinations.prepositional} в одном месте.</p>
<p>Стоимость подключения тарифов со скоростью интернета 100 ${speedMeasure()} составляет от ${
            useTag.price.priceMin
        } ${
            useTag.price.priceMin != useTag.price.priceMax
                ? `до ${useTag.price.priceMax}`
                : ""
        }  рублей в месяц, в зависимости от дополнительных услуг.</p>
${!!tariffNamesWithChannelList.length ? `${text()}` : ""}
<p>При подключении любого тарифа вы получите:</p>
<ul>
<li>надёжное сетевое подключение;</li>
<li>комфортную скорость для выполнения повседневных задач;</li>
<li>высокий уровень сервиса и помощь техподдержки.</li>
</ul>
<p>Для подключения достаточно оставить заявку на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const internet300Mbit101 = () => {
        let tariffNamesWithChannelList = !!tariffList.info
            .tariffNamesWithChannelList
            ? tariffList.info.tariffNamesWithChannelList.split(", ")
            : [];

        let text = () => {
            return `
<p>Помимо интернета, при подключении ${
                tariffNamesWithChannelList.length === 1 ? "тарифа" : "тарифов"
            } ${
                tariffList.info.tariffNamesWithChannelList
            } вы также получите доступ к телевизионным каналам.</p>
            `;
        };

        return `
<p>Если у вас большая семья, в которой все активно используют интернет, то иногда могут возникать проблемы со скоростью подключения. Чтобы их избежать, вы можете подключить тариф домашнего интернета со скоростью 300 ${speedMeasure()}.</p>
<p>Интернет 300 ${speedMeasure()} — это возможность обеспечить комфортную работу в сети сразу нескольким людям. Вы можете одновременно просматривать фильмы, работать, учиться и скачивать информацию. Скорости хватит на всё.</p>
<p>Провайдер ${
            providerInfo.name
        } готов обеспечить вам качественное соединение за выгодную цену от ${
            useTag.price.priceMin
        } ${
            useTag.price.priceMin != useTag.price.priceMax
                ? `до ${useTag.price.priceMax}`
                : ""
        } рублей в месяц.</p>
${!!tariffNamesWithChannelList.length ? `${text()}` : ""}
<p>Итак, если вам необходимо:</p>
<ul>
<li>выходить в интернет с нескольких устройств для выполнения различных задач;</li>
<li>обеспечивать корректную работу системы умного дома;</li>
<li>постоянно выгружать в сеть и скачивать из неё большие массивы данных.</li>
</ul>
<p>То вам стоит подключить интернет 300 ${speedMeasure()}.</p>
<p>На нашем сайте уже собрана вся необходимая информация об условиях и тарифах, вам остаётся только выбрать для себя подходящий.</p>
<p>Оставить заявку на подключение можно прямо на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const internet500Mbit101 = () => {
        let tariffNamesWithChannelList = !!tariffList.info
            .tariffNamesWithChannelList
            ? tariffList.info.tariffNamesWithChannelList.split(", ")
            : [];
        let tariffNamesWithMobileCallsSmsList = !!tariffList.info
            .tariffNamesWithMobileCallsSmsList
            ? tariffList.info.tariffNamesWithMobileCallsSmsList.split(", ")
            : [];

        let textTariffNameMobile = () => {
            return `
А при выборе ${tariffList.info.tariffNamesWithMobileCallsSmsList} — к пакетам минут разговоров и СМС.
            `;
        };

        let text = () => {
            return `
<p>Например, при подключении ${
                tariffNamesWithChannelList.length === 1 ? "тарифа" : "тарифов"
            }  ${
                tariffList.info.tariffNamesWithChannelList
            }, вы также получите доступ к телевизионным каналам. ${
                !!tariffNamesWithMobileCallsSmsList.length
                    ? `${textTariffNameMobile()}`
                    : ""
            }</p>
            `;
        };

        return `
<p>Если вы привыкли смотреть фильмы в высоком разрешении, то для вас очень важна хорошая скорость интернета. Домашний интернет 500 ${speedMeasure()} позволит вам смотреть кино в самом высоком качестве, не беспокоясь о том, что фильм зависнет.</p>
<p>Провайдер ${
            providerInfo.name
        } предоставляет возможность доступа к сети со скоростью от 500 ${speedMeasure()} по цене от ${
            useTag.price.priceMin
        } ${
            useTag.price.priceMin !== useTag.price.priceMax
                ? `до ${useTag.price.priceMax}`
                : ""
        } рублей в месяц, в зависимости от дополнительных услуг.</p>
${!!tariffNamesWithChannelList.length ? `${text()}` : ""}
<p>Благодаря оптоволоконному кабелю, ваше интернет-соединение будет не только быстрым, но и стабильным. А значит, проблемы с сигналом не помешают вам проводить время в сети.</p>
<p>Интернет со скоростью 500 ${speedMeasure()} — это:</p>
<ul>
<li>возможность скачивать большие объёмы данных за считаные минуты;</li>
<li>комфортное общение в видеозвонках с любым количеством участников.</li>
</ul>
<p>Чтобы подключить интернет 500 ${speedMeasure()}, оставьте заявку на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const onlineKinoteatr101 = () => {
        return `
<p>Иногда хочется провести вечер дома за просмотром любимого фильма. Для тех, кто предпочитает смотреть фильмы и сериалы онлайн, провайдер ${
            providerInfo.name
        } предлагает подключить домашний интернет с бесплатным доступом к одному из популярных онлайн-кинотеатров.</p>
<p>Онлайн-сервисы по просмотру фильмов и сериалов предоставляют возможность проводить акцию — бесплатный период доступа к онлайн-кинотеатру.</p>
<p>При выборе тарифа с подпиской на онлайн-кинотеатр у вас появляется замечательная возможность получить не только качественное интернет-соединение, но и доступ к множеству фильмов и сериалов.</p>
<p>Почему стоит подключить тариф домашнего интернета с подпиской на онлайн-кинотеатр:</p>
<ul>
<li>высокая скорость подключения, которой хватит и для работы, и для просмотра фильмов и сериалов в высоком разрешении;</li>
<li>доступ к онлайн-кинотеатру;</li>
<li>выгодная цена от ${useTag.price.priceMin} ${
            useTag.price.priceMin !== useTag.price.priceMax
                ? `до ${useTag.price.priceMax}`
                : ""
        } рублей в месяц.</li>
</ul>
<p>Мы собрали все подобные предложения в одном месте, и теперь вам осталось только выбрать подходящее и оставить заявку на нашем сайте.</p>
        `;
    };

    const internetIMobilnayaSvyazMoskva = () => {
        return `
<p>В большом количестве тарифов домашнего интернета и мобильной связи очень легко запутаться. Именно поэтому мы собрали все предложения от провайдера ${
            providerInfo.name
        } в одном месте и готовы помочь вам с выбором хорошего тарифа.</p>
<p>Прежде всего, стоит обратить внимание на скорость подключения:</p>
<ul>
<li>100 ${speedMeasure()} — хорошая скорость, которая подойдёт для решения повседневных задач в интернете;</li>
<li>200-500 ${speedMeasure()} — такую скорость стоит выбирать тем, кто живёт не один и выходит в сеть со множества различных устройств.</li>
<li>500 ${speedMeasure()} и выше — скорость интернет-подключения для настоящих киноманов, которые любят фильмы в самом высоком качестве, и любителей онлайн-игр, которым важна каждая секунда. Такое высокоскоростное соединение также необходимо тем, кто работает с большими объёмами данных и загружает их в сеть.</li>
</ul>
<p>Помимо отличного интернета, вы также получите ${
            useTag.mobile.callsMin != useTag.mobile.callsMax
                ? `от ${useTag.mobile.callsMin}`
                : ""
        } до ${useTag.mobile.callsMax} минут разговора и от ${
            useTag.mobile.smsMin
        } смс.</p>
<p>Таким образом, при подключении одного из тарифов с домашним интернетом и мобильной связью, вы получаете:</p>
<ul>
<li>качественное подключение на скорости ${
            useTag.internet.speedMin != useTag.internet.speedMax
                ? `от ${useTag.internet.speedMin}`
                : ""
        } до ${useTag.internet.speedMax} ${speedMeasure()};</li>
<li>пакет минут разговора и смс для общения по всей России;</li>
<li>выгодную цену всего от ${useTag.price.priceMin} рублей в месяц.</li>
</ul>
<p>Изучите все варианты тарифов и сделайте свой выбор. Оставить заявку на подключение понравившегося тарифа вы всегда можете прямо на нашем сайте.</p>
    `;
    };

    const internetTvMobileMoskva = () => {
        let tariffNamesInternetSpeedMaxList = !!tariffList.info
            .tariffNamesInternetSpeedMaxList
            ? tariffList.info.tariffNamesInternetSpeedMaxList.split(", ")
            : [];
        let tariffNamesMobileCallsMaxList = !!tariffList.info
            .tariffNamesMobileCallsMaxList
            ? tariffList.info.tariffNamesMobileCallsMaxList.split(", ")
            : [];
        let tariffNamesTvChannelsMaxList = !!tariffList.info
            .tariffNamesTvChannelsMaxList
            ? tariffList.info.tariffNamesTvChannelsMaxList.split(", ")
            : [];

        return `
<p>Выбор тарифа с интернетом, ТВ, мобильной связью — это отличный шанс подключить сразу всё необходимое для комфортной цифровой жизни в современном мире. Выходите в сеть для работы или учёбы, смотрите любимые фильмы и программы по телевизору, общайтесь с близкими по телефону — провайдер ${
            providerInfo.name
        } позаботится о том, чтобы это было комфортно и выгодно.</p>
<p>Цены на подключение тарифов, включающих интернет, ТВ и мобильную связь начинаются всего от ${
            useTag.price.priceMin
        } рублей в месяц. Осталось только решить, какой именно тариф выбрать.</p>
<p>Всё зависит от того, что именно для вас важно.</p>
<p>Если вы много работаете в интернете с большими массивами данных — лучше отдать предпочтение ${
            tariffNamesInternetSpeedMaxList.length === 1 ? "тарифу" : "тарифам"
        } ${
            tariffList.info.tariffNamesInternetSpeedMaxList
        }, с возможной скоростью подключения до ${
            useTag.internet.speedMax
        } ${speedMeasure()}.</p>
<p>${tariffNamesMobileCallsMaxList.length === 1 ? "Тариф" : "Тарифы"} ${
            tariffList.info.tariffNamesMobileCallsMaxList
        } — для тех, кому нужно много разговаривать по телефону. До ${
            useTag.mobile.callsMax
        } минут разговоров в месяц.</p>
<p>Если же вы не представляете свою жизнь без просмотра телепередач — вы точно оцените ${
            tariffNamesTvChannelsMaxList.length === 1 ? "тариф" : "тарифы"
        } ${
            tariffList.info.tariffNamesTvChannelsMaxList
        }. Вам станет доступно до ${
            useTag.tv.allChannelMax
        } каналов, из которых вы наверняка выберете для себя подходящий.</p>
<p>Какой бы тариф вы ни выбрали, в каждом из них вас ждут:</p>
<ul>
<li>доступ к интернету без зависаний и сбоев;</li>
<li>качественная телефонная связь;</li>
<li>доступ к каналам телевидения.</li>
</ul>
<p>Оставить заявку на подключение вы можете прямо на нашем сайте и с вами обязательно свяжутся.</p>
    `;
    };

    const domashnijInternetMoskva = () => {
        const textInternetOver100 = () => {
            return `<p>Если вам нужно загружать или скачивать большие объёмы данных, то лучше обратить внимание на тарифы со скоростью до ${
                useTag.internet.speedMax
            } ${speedMeasure()}.</p>
`;
        };

        return `
<p>В наше время домашний интернет есть практически в каждой квартире. Сложно представить себе человека, которому для просмотра фильмов или сериалов, общения с друзьями и переписки в многочисленных чатах не был бы нужен интернет.</p>
<p>Поэтому вопрос: “Какой домашний интернет выбрать?” — для многих является таким важным и сложным.</p>
<p>Именно поэтому мы собрали все предложения провайдера ${
            providerInfo.name
        } в одном месте. Вам нужно всего лишь зайти на наш сайт, где все тарифы с домашним интернетом будут перед вами.</p>
<p>Стоимость тарифов с домашним интернетом варьируется от ${
            useTag.price.priceMin
        } ${
            useTag.price.priceMin != useTag.price.priceMax
                ? `до ${useTag.price.priceMax}`
                : ""
        } рублей в месяц, в зависимости от скорости подключения, которую вы выберете.</p>
<p>Для повседневной работы и учёбы, а также просмотра фильмов и сериалов будет достаточно скорости до 100 ${speedMeasure()}.</p>
${useTag.internet.speedMax > 100 ? textInternetOver100() : ""}
<p>Стоит помнить, что чем больше людей одновременно используют сетевое подключение, тем выше должна быть его скорость.</p>
<p>Оставить заявку на подключение вы можете прямо на нашем сайте и с вами обязательно свяжутся.</p>
    `;
    };

    const internetITvMoskva = () => {
        return `
<p>Многих волнует вопрос — как выбрать хороший тариф интернета и телевидения? Ведь именно от качества подключения зависит, насколько удобным будет использование интернета и просмотр телевизора.</p>
<p>Чтобы сэкономить ваше время и помочь с выбором, мы собрали всю информацию о тарифах провайдера ${
            providerInfo.name
        } в одном месте. Теперь она доступна в виде удобной таблицы. Вам осталось только сравнить условия и выбрать для себя подходящий вариант.</p>
<p>Любой тариф с домашним интернетом и ТВ это:</p>
<ul>
<li>стабильное интернет-подключение на скорости ${
            useTag.internet.speedMin != useTag.internet.speedMax
                ? `от ${useTag.internet.speedMin}`
                : ""
        } до ${useTag.internet.speedMax} ${speedMeasure()};</li>
<li>большой выбор телевизионных каналов — ${
            useTag.tv.allChannelMin != useTag.tv.allChannelMax
                ? `от ${useTag.tv.allChannelMin}`
                : ""
        } до ${useTag.tv.allChannelMax};</li>
<li>доступная цена от ${useTag.price.priceMin} рублей в месяц.</li>
</ul>
<p>Выбирая тариф с интернетом и телевидением, вы экономите своё время, ведь теперь не придётся подключать услуги по отдельности. Подобный тариф выгоднее, чем отдельное подключение ТВ и интернета.</p>
<p>Для подключения тарифа достаточно просто оставить заявку на нашем сайте и с вами обязательно свяжутся.</p>
    `;
    };

    const nedorogojDomashnijInternetMoskva = () => {
        let tariffNamesTvChannelsMaxList = !!tariffList.info
            .tariffNamesTvChannelsMaxList
            ? tariffList.info.tariffNamesTvChannelsMaxList?.split(", ")
            : [];

        let text = () => {
            return `
<p>Дополнительным бонусом послужит наличие в ${
                tariffNamesTvChannelsMaxList.length === 1 ? "тарифе" : "тарифах"
            } ${
                tariffList.info.tariffNamesTvChannelsMaxList
            } доступа к телевизионным каналам. До ${
                useTag.tv.allChannelMax
            } каналов, из которых вы наверняка выберете для себя что-то интересное.</p>
            `;
        };

        return `
<p>Дешёвый тариф с интернетом — это отличная возможность подключить нужную услугу по выгодной цене. Сетевое подключение необходимо постоянно, чем бы вы ни занимались. Работа, общение, изучение нового, просмотр фильмов, онлайн-игры — стабильный интернет нужен всегда.</p>
<p>Именно поэтому провайдер ${
            providerInfo.name
        } проводит выгодные акции по подключению домашнего интернета. Это отличная возможность подключить качественный высокоскоростной интернет по хорошей цене от ${
            useTag.price.priceMin
        } рублей в месяц.</p>
<p>При этом вы получите:</p>
<ul>
<li>хорошую скорость интернета ${
            useTag.internet.speedMin != useTag.internet.speedMax
                ? `от ${useTag.internet.speedMin}`
                : ""
        } до ${useTag.internet.speedMax} ${speedMeasure()};</li>
<li>стабильное подключение;</li>
<li>квалифицированную помощь службы поддержки.</li>
</ul>
${!!tariffNamesTvChannelsMaxList.length ? `${text()}` : ""}
<p>Подключите один из выгодных тарифов с интернетом и получите возможность просматривать фильмы, общаться в социальных сетях, читать новости — и всё это по доступной цене.</p>
<p>Всегда непросто сделать выбор, особенно когда вариантов много. Чтобы облегчить вашу задачу, мы собрали все предложения в одном месте.</p>
<p>Чтобы подключить услугу, оставьте заявку на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const internet100MbitMoskva = () => {
        let tariffNamesWithChannelList = !!tariffList.info
            .tariffNamesWithChannelList
            ? tariffList.info.tariffNamesWithChannelList.split(", ")
            : [];
        let tariffNamesWithMobileCallsSmsList = !!tariffList.info
            .tariffNamesWithMobileCallsSmsList
            ? tariffList.info.tariffNamesWithMobileCallsSmsList.split(", ")
            : [];

        let textTariffNameChannel = () => {
            return `
            Кроме того, при подключении ${
                tariffNamesWithChannelList.length === 1 ? "тарифа" : "тарифов"
            } ${
                tariffList.info.tariffNamesWithChannelList
            } вы получите доступ к телевизионным каналам.
            `;
        };

        let textTariffNameMobile = () => {
            return `
            А выбирая ${
                tariffNamesWithMobileCallsSmsList.length === 1
                    ? "тариф"
                    : "тарифы"
            } ${
                tariffList.info.tariffNamesWithMobileCallsSmsList
            } — пакеты минут для разговоров и СМС.
            `;
        };

        let text = () => {
            return `
<p>${!!tariffNamesWithChannelList.length ? `${textTariffNameChannel()}` : ""} ${
                !!tariffNamesWithMobileCallsSmsList.length
                    ? `${textTariffNameMobile()}`
                    : ""
            }</p>
            `;
        };

        return `
<p>При выборе тарифа интернета для дома скорость является одним из определяющих факторов. Домашний интернет со скоростью 100 ${speedMeasure()} — это возможность заниматься делами, общаться, просматривать новости и смотреть фильмы в хорошем качестве.</p>
<p>Обычно, чтобы выбрать хороший тариф, нужно просмотреть множество сайтов, сравнить все варианты, проанализировать их. Всё это отнимает много времени. Чтобы вам не пришлось этого делать, мы собрали все предложения провайдера ${
            providerInfo.name
        } в одном месте.</p>
<p>100 ${speedMeasure()} — это комфортная скорость, которой будет достаточно для выполнения всех повседневных задач. Подключить тариф с интернетом 100 ${speedMeasure()} можно по цене от ${
            useTag.price.priceMin
        } рублей в месяц.</p>
<p>За эту стоимость вы получите:</p>
<ul>
<li>надёжное сетевое подключение;</li>
<li>комфортную скорость для выполнения повседневных задач;</li>
<li>высокий уровень сервиса и помощь техподдержки.</li>
</ul>
${
    !!tariffNamesWithChannelList?.length ||
    !!tariffNamesWithMobileCallsSmsList?.length
        ? `${text()}`
        : ""
}
<p>Для подключения достаточно оставить заявку на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const internet300MbitMoskva = () => {
        let tariffNamesWithChannelList = !!tariffList.info
            .tariffNamesWithChannelList
            ? tariffList.info.tariffNamesWithChannelList.split(", ")
            : [];
        let tariffNamesWithMobileCallsList = !!tariffList.info
            .tariffNamesWithMobileCallsList
            ? tariffList.info.tariffNamesWithMobileCallsList.split(", ")
            : [];

        let textTariffChannel = () => {
            return `
телевизионным каналам в ${
                tariffNamesWithChannelList.length === 1 ? "тарифе" : "тарифах"
            } ${tariffList.info.tariffNamesWithChannelList}
            `;
        };

        let textTariifMinute = () => {
            return `
пакетам минут разговора в ${tariffList.info.tariffNamesWithMobileCallsList}
            `;
        };

        let text = () => {
            return `
<p>Приятным бонусом будет доступ к ${
                !!tariffNamesWithChannelList.length
                    ? `${textTariffChannel()}`
                    : ""
            } ${
                !!tariffNamesWithChannelList.length &&
                !!tariffNamesWithMobileCallsList.length
                    ? "или"
                    : ""
            } ${
                !!tariffNamesWithMobileCallsList.length
                    ? `${textTariifMinute()}`
                    : ""
            }.</p>
            `;
        };

        return `
<p>Чем больше устройств подключается к сети, тем выше нужна скорость соединения, чтобы обеспечить корректную работу. Смартфоны, ноутбуки, компьютеры, устройства умного дома — подключите интернет 300 ${speedMeasure()} и скорости хватит для всего.</p>
<p>Каждому хочется иметь быстрый домашний интернет, о скорости которого не нужно беспокоиться. Оптоволоконный кабель позволяет предоставить подключение со скоростью от 300 ${speedMeasure()}.</p>
<p>Провайдер ${
            providerInfo.name
        } готов предложить вам качественное соединение за выгодную цену от ${
            useTag.price.priceMin
        } ${
            useTag.price.priceMin != useTag.price.priceMax
                ? `до ${useTag.price.priceMax}`
                : ""
        } рублей в месяц, в зависимости от дополнительных услуг.</p>
<p>Возможно, вам знакомы следующие ситуации:</p>
<ul>
<li>фильмы часто зависают на середине просмотра и приходится ждать, когда они загрузятся;</li>
<li>по вечерам, когда вся семья дома, интернет-страницы открываются очень долго;</li>
<li>скачивание данных растягивается на несколько часов.</li>
</ul>
<p>Со всеми этими трудностями может помочь подключение тарифа с интернетом 300 ${speedMeasure()}. Подберите для себя подходящий и забудьте обо всех проблемах, связанных с низкой скоростью интернета.</p>
${
    !!tariffNamesWithChannelList.length ||
    !!tariffNamesWithMobileCallsList.length
        ? `${text()}`
        : ""
}
<p>Выбрать подходящий для себя тариф и оставить заявку на подключение вы можете прямо на нашем сайте.</p>
        `;
    };

    const internet500MbitMoskva = () => {
        return `
<p>Бывают моменты, когда необходима максимальная скорость интернета. Например, если вы любите играть в онлайн-игры, то знаете, что каждая секунда может стать решающей. Или если вам часто приходится загружать в облачные хранилища большие объёмы данных, и вы не хотите тратить на это несколько часов. Именно для вас созданы тарифы интернета со скоростью 500 ${speedMeasure()}.</p>
<p>Провайдер ${
            providerInfo.name
        } предоставляет возможность доступа к сети со скоростью 500 ${speedMeasure()} по цене от ${
            useTag.price.priceMin
        } ${
            useTag.price.priceMin !== useTag.price.priceMax
                ? `до ${useTag.price.priceMax}`
                : ""
        } рублей в месяц.</p>
<p>За эту цену вы получите не только быстрое и стабильное соединение, но и доступ к пакетам ТВ-каналов и мобильной связи.</p>
<p>Зачем нужен интернет со скоростью 500 ${speedMeasure()}:</p>
<ul>
<li>возможность скачивать большие объёмы данных за несколько минут;</li>
<li>комфортное общение в видеозвонках с любым количеством участников;</li>
<li>возможность принимать участие в любых онлайн-играх.</li>
</ul>
<p>Чтобы вам не пришлось тратить своё время на анализ различных сайтов, мы собрали все доступные предложения в одном месте.</p>
<p>Чтобы подключить интернет 500 ${speedMeasure()} у себя в квартире, оставьте заявку на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const onlineKinoteatrMoskva = () => {
        return `
<p>Все любят посмотреть хороший фильм на большом экране, но в ритме современной жизни не всегда есть возможность посетить кинотеатр. Отличным выходом в такой ситуации станет онлайн-кинотеатр, в котором можно насладиться последними новинками или любимой классикой.</p>
<p>Онлайн-сервисы по просмотру фильмов и сериалов предоставляют интернет-провайдеру ${providerInfo.name} возможность проводить акцию — бесплатный пробный период доступа к одному из кинотеатров.</p>
<p>Тариф с домашним интернетом и онлайн-кинотеатром это:</p>
<ul>
<li>качественное интернет-соединение без перебоев;</li>
<li>высокая скорость, которая обеспечит комфортную работу в сети;</li>
<li>квалифицированная помощь техподдержки.</li>
</ul>
<p>При выборе тарифа с подпиской на онлайн-кинотеатр у вас появляется замечательная возможность получить не только качественное интернет-соединение, но и доступ к множеству фильмов, сериалов и мультфильмов.</p>
<p>Мы собрали все подобные предложения в одном месте, и теперь вам осталось только выбрать подходящее и оставить заявку на нашем сайте.</p>
        `;
    };

    const internetIMobilnayaSvyazPiter = () => {
        return `
<p>К выбору домашнего интернета стоит подходить очень ответственно. От того, насколько быстрым и стабильным будет подключение, зависит то, насколько комфортно вам будет работать и проводить время в сети.</p>
<p>Провайдер ${
            providerInfo.name
        } предоставляет тарифы с домашним интернетом и мобильной связью по цене ${
            useTag.price.priceMin != useTag.price.priceMax
                ? `от ${useTag.price.priceMin}`
                : ""
        } до ${useTag.price.priceMax} рублей в месяц.</p>
<p>Цена напрямую зависит от скорости подключения, поэтому так важно понимать, какая скорость вам необходима. Мы сделали короткую памятку, чтобы помочь вам определиться.</p>
<ul>
<li>Выбирайте 100 ${speedMeasure()}, если вы используете интернет для повседневных задач, таких как работа, просмотр фильмов и чтение новостей;</li>
<li>200-500 ${speedMeasure()} — подойдёт тем, у кого большая семья и доступ к интернету нужен со множества разных устройств;</li>
<li>500 ${speedMeasure()} и выше — для тех, кто не любит себя ограничивать и хочет использовать возможности соединения по максимуму. Фильмы в высоком качестве, загрузка больших объёмов данных, скачивание игр — скорости хватит на всё.</li>
</ul>
<p>Выгодный тариф мобильной связи с интернетом — это не только стабильное подключение к сети по ${
            region.declinations.dative
        }, но и пакеты минут разговора от ${
            useTag.mobile.callsMin
        } минут в месяц.</p>
<p>Итак, подключая тариф интернета и мобильной связи, вы получаете:</p>
<ul>
<li>высокую скорость соединения ${
            useTag.internet.speedMin != useTag.internet.speedMax
                ? `от ${useTag.internet.speedMin}`
                : ""
        } до ${useTag.internet.speedMax} ${speedMeasure()};</li>
<li>стабильный телефонный сигнал без помех и посторонних шумов на фоне;</li>
<li>возможность подключения сразу двух необходимых услуг одновременно;</li>
<li>выгодную цену от ${useTag.price.priceMin} рублей в месяц.</li>
</ul>
<p>Сравнить все тарифы и выбрать для себя наиболее подходящий вы можете на нашем сайте. Для подключения необходимо оставить заявку и с вами обязательно свяжутся.</p>
    `;
    };

    const internetTvMobilePiter = () => {
        let tariffNamesInternetSpeedMaxList = !!tariffList.info
            .tariffNamesInternetSpeedMaxList
            ? tariffList.info.tariffNamesInternetSpeedMaxList.split(", ")
            : [];
        let tariffNamesMobileCallsMaxList = !!tariffList.info
            .tariffNamesMobileCallsMaxList
            ? tariffList.info.tariffNamesMobileCallsMaxList.split(", ")
            : [];
        let tariffNamesTvChannelsMaxList = !!tariffList.info
            .tariffNamesTvChannelsMaxList
            ? tariffList.info.tariffNamesTvChannelsMaxList.split(", ")
            : [];

        return `
<p>Подключение тарифа с интернетом, ТВ и мобильной связью — не только выгодно, но и удобно. Ведь это позволяет оплачивать все необходимые услуги одновременно и в одном месте. Подключив тариф с домашним интернетом, ТВ, мобильной связью, вы сможете наслаждаться любимыми программами, общаться с близкими, работать, играть в онлайн-игры, следить за новостями и всё это по цене от ${
            useTag.price.priceMin
        } рублей в месяц.</p>
<p>Провайдер ${
            providerInfo.name
        } предоставляет широкий выбор тарифов, включающих следующие услуги:</p>
<ul>
<li>интернет-соединение на скорости ${
            useTag.internet.speedMin != useTag.internet.speedMax
                ? `от ${useTag.internet.speedMin}`
                : ""
        } до ${useTag.internet.speedMax} ${speedMeasure()};</li>
<li>мобильная связь ${
            useTag.mobile.callsMin != useTag.mobile.callsMax
                ? `от ${useTag.mobile.callsMin}`
                : ""
        } до ${useTag.mobile.callsMax} минут разговоров в месяц;</li>
<li>возможность просмотра ${
            useTag.tv.allChannelMin != useTag.tv.allChannelMax
                ? `от ${useTag.tv.allChannelMin}`
                : ""
        } до ${useTag.tv.allChannelMax} телевизионных каналов.</li>
</ul>
<p>Вам остаётся только решить, какой именно тариф интернета, ТВ, мобильной связи выбрать.</p>
<p>Это зависит от того, какая услуга для вас наиболее важна.</p>
<p>Если вы много работаете в интернете с большими массивами данных — отдайте предпочтение ${
            tariffNamesInternetSpeedMaxList.length === 1 ? "тарифу" : "тарифам"
        } ${
            tariffList.info.tariffNamesInternetSpeedMaxList
        }, с максимально возможной скоростью интернет-подключения.</p>
<p>${tariffNamesMobileCallsMaxList.length === 1 ? "Тариф" : "Тарифы"} ${
            tariffList.info.tariffNamesMobileCallsMaxList
        } — для тех, кому нужно много разговаривать по телефону.</p>
<p>Если вы не представляете свою жизнь без просмотра телевизора — вы точно оцените ${
            tariffNamesTvChannelsMaxList.length === 1 ? "тариф" : "тарифы"
        } ${tariffList.info.tariffNamesTvChannelsMaxList}.</p>
<p>Мы собрали все предложения в одном месте, чтобы вы могли с лёгкостью сравнить их и выбрать наиболее подходящий вариант.</p>
<p>Оставить заявку на подключение можно прямо на нашем сайте и с вами обязательно свяжутся.</p>
    `;
    };

    const domashnijInternetPiter = () => {
        let tariffNamesInternetSpeedUnder100List = !!tariffList.info
            .tariffNamesInternetSpeedUnder100List
            ? tariffList.info.tariffNamesInternetSpeedUnder100List.split(", ")
            : [];
        let tariffNamesInternetSpeedOver100List = !!tariffList.info
            .tariffNamesInternetSpeedOver100List
            ? tariffList.info.tariffNamesInternetSpeedOver100List.split(", ")
            : [];

        const textInternetUnder100 = () => {
            return `<li>${
                tariffNamesInternetSpeedUnder100List.length === 1
                    ? "тариф"
                    : "тарифы"
            } ${
                tariffList.info.tariffNamesInternetSpeedUnder100List
            } — скорость до 100 ${speedMeasure()}, подойдёт тем, кому интернет нужен для повседневных задач;</li>`;
        };
        const textInternetOver100 = () => {
            return `<li>${
                tariffNamesInternetSpeedOver100List.length === 1
                    ? "тариф"
                    : "тарифы"
            } ${
                tariffList.info.tariffNamesInternetSpeedOver100List
            } — скорость до ${
                useTag.internet.speedMax
            } ${speedMeasure()}. Идеальный вариант для большой семьи, где каждому нужно работать, смотреть фильмы, учиться.</li>`;
        };

        return `
<p>Рано или поздно с выбором домашнего интернета сталкивается каждый человек. Всем хочется получить хорошее подключение без переплат и лишних хлопот.</p>
<p>Чтобы вам не пришлось тратить своё время на поиски информации, мы собрали все данные о тарифах провайдера ${
            providerInfo.name
        } на нашем сайте.</p>
<p>Выберите для себя подходящий вариант:</p>
<ul>
${tariffNamesInternetSpeedUnder100List.length ? textInternetUnder100() : ""}
${tariffNamesInternetSpeedOver100List.length ? textInternetOver100() : ""}
</ul>
<p>В любом выбранном вами тарифе будут:</p>
<ul>
<li>отличный высокоскоростной интернет;</li>
<li>подключение без сбоев и зависаний;</li>
<li>оперативная поддержка провайдера.</li>
</ul>
<p>Оставить заявку на подключение вы можете прямо на нашем сайте.</p>
    `;
    };

    const internetITvPiter = () => {
        let tariffNamesInternetSpeedMinList = !!tariffList.info
            .tariffNamesInternetSpeedMinList
            ? tariffList.info.tariffNamesInternetSpeedMinList.split(", ")
            : [];
        let tariffNamesInternetSpeedMaxList = !!tariffList.info
            .tariffNamesInternetSpeedMaxList
            ? tariffList.info.tariffNamesInternetSpeedMaxList.split(", ")
            : [];

        let text = () => {
            return `от ${useTag.internet.speedMin} ${speedMeasure()} в ${
                tariffNamesInternetSpeedMinList.length === 1
                    ? "тарифе"
                    : "тарифах"
            } ${tariffList.info.tariffNamesInternetSpeedMinList},`;
        };

        return `
<p>Стабильный интернет и хорошее ТВ — одни из составляющих комфортной и счастливой жизни. Если вы хотите наслаждаться любимыми телепрограммами, общаться в социальных сетях, играть в онлайн-игры и т.д., стоит задуматься о хорошем тарифе домашнего интернета и телевидения.</p>
<p>Чтобы вам не пришлось тратить время на поиск информации, мы собрали все данные о тарифных планах провайдера ${
            providerInfo.name
        } в одном месте.</p>
<p>Выберите необходимую вам скорость подключения ${
            useTag.internet.speedMin != useTag.internet.speedMax ? text() : ""
        } до ${useTag.internet.speedMax} ${speedMeasure()} в ${
            tariffNamesInternetSpeedMaxList.length === 1 ? "тарифе" : "тарифах"
        } ${
            tariffList.info.tariffNamesInternetSpeedMaxList
        }. В любом случае соединение будет стабильным и надёжным.</p>
<p>Выбор из ${
            useTag.tv.allChannelMin != useTag.tv.allChannelMax
                ? `${useTag.tv.allChannelMin}-`
                : ""
        }${
            useTag.tv.allChannelMax
        } каналов позволит каждому найти для себя что-то интересное.</p>
<p>Тариф с домашним интернетом и ТВ это:</p>
<ul>
<li>высокоскоростное интернет-соединение;</li>
<li>доступ к большому количеству телевизионных каналов;</li>
<li>выгодная цена от ${useTag.price.priceMin} рублей в месяц.</li>
</ul>
<p>Чтобы подключить тариф, оставьте заявку на нашем сайте и с вами обязательно свяжутся.</p>
    `;
    };

    const nedorogojDomashnijInternetPiter = () => {
        let tariffNamesWithChannelList = !!tariffList.info
            .tariffNamesWithChannelList
            ? tariffList.info.tariffNamesWithChannelList.split(", ")
            : [];
        let tariffNamesWithMobileCallsList = !!tariffList.info
            .tariffNamesWithMobileCallsList
            ? tariffList.info.tariffNamesWithMobileCallsList.split(", ")
            : [];

        let textTariffNameChannel = () => {
            return `
<li>доступ к телеканалам в ${tariffList.info.tariffNamesWithChannelList};</li>
            `;
        };
        let textTariffNameMinute = () => {
            return `
<p>Дополнительным плюсом будет наличие пакетов минут разговора при подключении  ${
                tariffNamesWithMobileCallsList.length === 1
                    ? "тарифа"
                    : "тарифов"
            } ${tariffList.info.tariffNamesWithMobileCallsList}.</p>
            `;
        };

        return `
<p>Выгодные тарифы домашнего интернета — это уникальные предложения от провайдера ${
            providerInfo.name
        }. Подключите необходимую услугу по цене от ${
            useTag.price.priceMin
        } рублей в месяц. Стабильное качественное подключение — это гарантия комфортной работы в интернете. А проводимые акции — возможность ознакомиться с тарифом на выгодных условиях.</p>
<p>Подключите выгодный тариф с интернетом и получите:</p>
<ul>
<li>скорость подключения ${
            useTag.internet.speedMin != useTag.internet.speedMax
                ? `от ${useTag.internet.speedMin}`
                : ""
        } до ${useTag.internet.speedMax} ${speedMeasure()};</li>
${!!tariffNamesWithChannelList.length ? `${textTariffNameChannel()}` : ""}
<li>отличный сервис и внимательный подход к каждому клиенту.</li>
</ul>
${!!tariffNamesWithMobileCallsList.length ? `${textTariffNameMinute()}` : ""}
<p>Выбирайте скорость подключения исходя из ваших потребностей и подключайте один из выгодных тарифов с интернетом прямо сейчас.</p>
<p>Чтобы немного облегчить вашу задачу, мы собрали все предложения от провайдера в одном месте. Теперь вам осталось только сравнить условия и выбрать для себя наиболее подходящее.</p>
<p>Чтобы подключить услугу, оставьте заявку на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const internet100MbitPiter = () => {
        let tariffNamesWithChannelList = !!tariffList.info
            .tariffNamesWithChannelList
            ? tariffList.info.tariffNamesWithChannelList.split(", ")
            : [];
        let tariffNamesWithMobileCallsSmsList = !!tariffList.info
            .tariffNamesWithMobileCallsSmsList
            ? tariffList.info.tariffNamesWithMobileCallsSmsList.split(", ")
            : [];

        let textTariffNameChannel = () => {
            return `
Кроме того, при подключении ${
                tariffNamesWithChannelList.length === 1 ? "тарифа" : "тарифов"
            } ${
                tariffList.info.tariffNamesWithChannelList
            } вы получите доступ к телевизионным каналам.
            `;
        };

        let textTariffNameMobile = () => {
            return `
А выбирая ${
                tariffNamesWithMobileCallsSmsList.length === 1
                    ? "тариф"
                    : "тарифы"
            } ${
                tariffList.info.tariffNamesWithMobileCallsSmsList
            } — пакеты минут для разговоров и СМС.
            `;
        };

        let text = () => {
            return `
<p>${!!tariffNamesWithChannelList.length ? `${textTariffNameChannel()}` : ""} ${
                !!tariffNamesWithMobileCallsSmsList.length
                    ? `${textTariffNameMobile()}`
                    : ""
            }</p>
            `;
        };

        return `
<p>При выборе тарифа интернета для дома скорость является одним из определяющих факторов. Домашний интернет со скоростью 100 ${speedMeasure()} — это возможность заниматься делами, общаться, просматривать новости и смотреть фильмы в хорошем качестве.</p>
<p>Обычно, чтобы выбрать хороший тариф, нужно просмотреть множество сайтов, сравнить все варианты, проанализировать их. Всё это отнимает много времени. Чтобы вам не пришлось этого делать, мы собрали все предложения провайдера ${
            providerInfo.name
        } в одном месте.</p>
<p>100 ${speedMeasure()} — это комфортная скорость, которой будет достаточно для выполнения всех повседневных задач. Подключить тариф с интернетом 100 ${speedMeasure()} можно по цене от ${
            useTag.price.priceMin
        } рублей в месяц.</p>
<p>За эту стоимость вы получите:</p>
<ul>
<li>надёжное сетевое подключение;</li>
<li>комфортную скорость для выполнения повседневных задач;</li>
<li>высокий уровень сервиса и помощь техподдержки.</li>
</ul>
${
    !!tariffNamesWithChannelList.length ||
    !!tariffNamesWithMobileCallsSmsList.length
        ? `${text()}`
        : ""
}
<p>Для подключения достаточно оставить заявку на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const internet300MbitPiter = () => {
        let tariffNamesWithChannelList = !!tariffList.info
            .tariffNamesWithChannelList
            ? tariffList.info.tariffNamesWithChannelList.split(", ")
            : [];

        let text = () => {
            return `
<p>Кроме того, подключая тарифы ${tariffList.info.tariffNamesWithChannelList} вы получите доступ к минимум ${useTag.tv.allChannelMin} телевизионным каналам.</p>
            `;
        };

        return `
<p>Если вы привыкли активно использовать интернет, читать новости, смотреть фильмы, играть в онлайн-игры и использовать облачные сервисы, то интернет со скоростью 300 ${speedMeasure()} — это то, что вам нужно.</p>
<p>Каждому хотелось бы иметь быстрый домашний интернет, о скорости которого не приходится переживать, чем бы вы ни занимались. Скорость 300 ${speedMeasure()} особенно нужна тем, у кого большая семья или планируется установка системы умного дома. Ведь чем больше устройств одновременно подключаются к сети, тем хуже становится сигнал.</p>
<p>Провайдер ${
            providerInfo.name
        } готов обеспечить вам качественное соединение за выгодную цену от ${
            useTag.price.priceMin
        } рублей в месяц.</p>
<p>Если вы часто сталкиваетесь с тем, что:</p>
<ul>
<li>видеозвонки не проходят или зависают на середине разговора, а изображение плохого качества;</li>
<li>по вечерам, когда вся семья дома, интернет-страницы открываются очень долго или не загружаются совсем;</li>
<li>скачивание данных растягивается на несколько часов.</li>
</ul>
<p>В таком случае вам стоит подключить тариф с интернетом 300 ${speedMeasure()}. Выберите для себя подходящий и забудьте обо всех проблемах, связанных с низкой скоростью интернета.</p>
${!!tariffNamesWithChannelList.length ? `${text()}` : ""}
<p>Оставить заявку на подключение можно прямо на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const internet500MbitPiter = () => {
        let tariffNamesWithChannelList = !!tariffList.info
            .tariffNamesWithChannelList
            ? tariffList.info.tariffNamesWithChannelList.split(", ")
            : [];

        let text = () => {
            return `
<p>Приятным дополнением станет наличие телевизионных каналов в ${
                tariffNamesWithChannelList.length === 1 ? "тарифе" : "тарифах"
            } ${tariffList.info.tariffNamesWithChannelList}.</p>
            `;
        };

        return `
<p>Если вы планируете установку системы умного дома, то наверняка задумывались о том, хватит ли вашей скорости интернета. Ведь чем больше устройств подключается к сети, тем выше должна быть скорость подключения, чтобы её хватило на все из них.</p>
<p>Именно поэтому провайдер ${
            providerInfo.name
        } предлагает тарифные планы с возможностью доступа к сети на скорости от 500 ${speedMeasure()}.</p>
<p>Вам гарантируется не только быстрое, но и стабильное соединение, которое не прервётся и не зависнет. То есть вы будете уверены в корректной работе всех устройств.</p>
<p>Подключая интернет со скоростью 500 ${speedMeasure()}, вы получаете возможность:</p>
<ul>
<li>смотреть фильмы и сериалы в самом высоком качестве;</li>
<li>общаться по видеосвязи, наслаждаясь прекрасным и чётким изображением;</li>
<li>одновременно выходить в сеть с нескольких устройств, не мешая друг другу;</li>
<li>подключать большое количество устройств умного дома.</li>
</ul>
${!!tariffNamesWithChannelList.length ? `${text()}` : ""}
<p>Чтобы вам не пришлось тратить своё время на анализ различных сайтов, мы собрали все предложения провайдера в одном месте. Вам осталось только выбрать подходящее.</p>
<p>Для подключения тарифа оставьте заявку на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const onlineKinoteatrPiter = () => {
        return `
<p>В последние годы сервисы онлайн-кинотеатров стали особенно популярны. Многие предпочитают не тратить время на походы в кинотеатр, а посмотреть фильм дома. Высокая скорость домашнего интернета в тарифах от провайдера ${
            providerInfo.name
        } позволяет обеспечить прекрасное качество звука и изображения.</p>
<p>Специально для любителей домашних киновечеров онлайн-сервисы предоставляют возможность проводить акцию — бесплатный период доступа к онлайн-кинотеатру.</p>
<p>При выборе тарифа с подпиской на онлайн-кинотеатр у вас появляется замечательная возможность получить не только качественное интернет-соединение, но и доступ к множеству фильмов и сериалов.</p>
<p>Подключайте тариф с доступом к онлайн-кинотеатру и получайте возможность:</p>
<ul>
<li>смотреть фильмы, сериалы, мультфильмы и телепрограммы в любое время;</li>
<li>использовать преимущества сетевого подключения по максимуму, благодаря скорости до ${
            useTag.internet.speedMax
        } ${speedMeasure()}.</li>
</ul>
<p>Мы собрали все предложения домашнего интернета с доступом к онлайн-кинотеатру в одном месте. Теперь вам осталось только выбрать подходящее и оставить заявку на подключение на нашем сайте.</p>
        `;
    };

    const tagName101 = {
        "internet-i-mobilnaya-svyaz": internetIMobilnayaSvyaz101,
        "internet-tv-mobile": internetTvMobile101,
        "domashnij-internet": domashnijInternet101,
        "internet-i-tv": internetITv101,
        "nedorogoj-domashnij-internet": nedorogojDomashnijInternet101,
        "internet-100-mbit": internet100Mbit101,
        "internet-300-mbit": internet300Mbit101,
        "internet-500-mbit": internet500Mbit101,
        "online-kinoteatr": onlineKinoteatr101,
    };

    const tagNameMoskva = {
        "internet-i-mobilnaya-svyaz": internetIMobilnayaSvyazMoskva,
        "internet-tv-mobile": internetTvMobileMoskva,
        "domashnij-internet": domashnijInternetMoskva,
        "internet-i-tv": internetITvMoskva,
        "nedorogoj-domashnij-internet": nedorogojDomashnijInternetMoskva,
        "internet-100-mbit": internet100MbitMoskva,
        "internet-300-mbit": internet300MbitMoskva,
        "internet-500-mbit": internet500MbitMoskva,
        "online-kinoteatr": onlineKinoteatrMoskva,
    };

    const tagNamePiter = {
        "internet-i-mobilnaya-svyaz": internetIMobilnayaSvyazPiter,
        "internet-tv-mobile": internetTvMobilePiter,
        "domashnij-internet": domashnijInternetPiter,
        "internet-i-tv": internetITvPiter,
        "nedorogoj-domashnij-internet": nedorogojDomashnijInternetPiter,
        "internet-100-mbit": internet100MbitPiter,
        "internet-300-mbit": internet300MbitPiter,
        "internet-500-mbit": internet500MbitPiter,
        "online-kinoteatr": onlineKinoteatrPiter,
    };

    const siteCodeName = {
        "101internet": tagName101,
        moskvaonline: tagNameMoskva,
        piteronline: tagNamePiter,
    };

    let seoTextView = siteCodeName[siteCode][tagCode];

    if (!!seoTextView && !!useTag) {
        return (
            <div
                dangerouslySetInnerHTML={{
                    __html: seoTextView(),
                }}
            />
        );
    } else {
        return null;
    }
};

export default withRouter(withDefaultParams(SeoTextProviderRatesTags));
